export default "__VITE_ASSET__5413ab4b__"